import '../LandingPage.css';

const steps = [
  {
    title: 'Tell us what you need',
    text: 'Call, email or use the chat. Describe what the application should do and who will use it, and we reply with the questions we need answered to plan it.',
  },
  {
    title: 'Agree on a plan',
    text: 'We write down what we will build, in which order and what it is likely to cost. You approve it before any work starts.',
  },
  {
    title: 'Build, launch and look after it',
    text: 'We build in short stages so you can try working software early. After launch we host the application and keep it up to date.',
  },
];

function ProcessSection() {
  return (
    <section id="process" className="process-section section" aria-labelledby="process-title">
      <div className="section-content">
        <div className="section-head reveal">
          <h2 id="process-title" className="section-title">How a project works</h2>
        </div>

        <ol className="process-list">
          {steps.map((step, index) => (
            <li
              key={step.title}
              className={`process-step reveal ${index > 0 ? `reveal-delay-${index}` : ''}`}
            >
              <span className="process-step-number" aria-hidden="true">
                {index + 1}
              </span>
              <h3 className="process-step-title">{step.title}</h3>
              <p className="process-step-text">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default ProcessSection;
